import PropTypes from "prop-types";

export const pathoArrayType = PropTypes.arrayOf(
  PropTypes.shape({
    acmg_class: PropTypes.string,
    coding_impact: PropTypes.string,
    gene_symbol: PropTypes.string,
    hgvs: PropTypes.string,
    pretty_spec: PropTypes.string,
    source: PropTypes.string,
    spec: PropTypes.string,
    transcript: PropTypes.string,
    variant_id: PropTypes.string,
    codon: PropTypes.number,
  })
);
